import * as Yup from 'yup';
import messages from './registerForm.messages';
import { REGISTRATION_FIELDS as FIELDS } from '../../../modules/auth/auth.constants';

export const defaultValues = {
  [FIELDS.firstName]: '',
  [FIELDS.lastName]: '',
  [FIELDS.email]: '',
  [FIELDS.password]: '',
  [FIELDS.agreements1]: false,
  [FIELDS.agreements2]: false,
};

export const RegisterSchema = Yup.object().shape({
  [FIELDS.firstName]: Yup.string().required(messages.fieldRequired),
  [FIELDS.lastName]: Yup.string().required(messages.fieldRequired),
  [FIELDS.email]: Yup.string()
    .email(messages.incorrectEmailFormat)
    .required(messages.fieldRequired),
  [FIELDS.password]: Yup.string().required(messages.fieldRequired),
  [FIELDS.agreements1]: Yup.boolean().nullable(false),
  [FIELDS.agreements2]: Yup.mixed().oneOf([true], messages.fieldRequired),
});
